import {stylePatterns} from '../../theme/patterns';
import {useStyles} from '../../hooks/styles';

import {Theme} from '../../theme/interface';

const cardWidth = 316;
const cardHeight = 206;
const cardBlockedVisImpWidth = 383;
const cardBlockedVisImpHeight = 252;

export const GetStyles = (theme: Theme, isVisImpActive: boolean, isVisImpFontLarge: boolean, uscIsBlocked: boolean) => {
  const styles = useStyles(() => ({
    wrap: {
      ...stylePatterns.flexCenterFull,
      position: 'relative',
      marginTop: -45,
    },
    tracery: {
      top: -10,
      left: -10,
      position: 'relative',
      width: 585,
      height: 483,
    },
    cardContainer: {
      marginTop: -40,
      marginLeft: 30,
      position: 'absolute',
      width: isVisImpFontLarge && uscIsBlocked ? cardBlockedVisImpWidth : cardWidth,
      height: isVisImpFontLarge && uscIsBlocked ? cardBlockedVisImpHeight : cardHeight,
    },
    cardLayout: {
      width: '100%',
      height: '100%',
      borderColor: theme.profileCard.cardBorderColor,
      borderWidth: isVisImpActive ? 1 : 0,
      backgroundColor: isVisImpActive ? theme.color.black : undefined,
      ...theme.profileCard.cardWrapShadow,
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 10,
    },
    buttonContainer: {
      position: 'absolute',
      left: 0,
      bottom: -63,
      flexDirection: 'row',
      justifyContent: 'center',
      width: isVisImpFontLarge && uscIsBlocked ? cardBlockedVisImpWidth : cardWidth,
    },
    button: {
      margin: 'auto',
      flexDirection: 'row',
      alignItems: 'center',
    },
    buttonIcon: {
      color: theme.color.primaryColor,
    },
    buttonText: {
      color: theme.color.primaryColor,
      marginLeft: 8,
    },
  }));

  return styles;
};
